<template>
  <date-time-timezone
    mode="date"
    :field="field"
    :value="value"
    :disabled="disabled"
    :element-id="elementId"
    @update:value="onInput"
    @changed="validate"
  />
</template>

<script>
import DateTimeTimezone from './DateTimeTimezone';
import Field from './Field';

export default {
  components: { DateTimeTimezone },
  extends: Field,
  data() {
    return {
      requiredValidator: 'requiredDate'
    };
  }
};
</script>
